import { Box, Typography } from "@mui/material";

const DashboardStatCard = ({ title, value, variation, icon, color }) => (
  <Box
    sx={{
      p: 2.5,
      borderRadius: 3,
      boxShadow: '0 2px 12px 0 rgba(99, 99, 99, 0.08)',
      backgroundColor: "white",
      height: "100%",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.03)',
        boxShadow: '0 4px 20px 0 rgba(99, 99, 99, 0.2)',
      },
      border: '1px solid #f1f3f4',
      fontFamily: 'Montserrat, Arial, sans-serif',
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 700, fontSize: 15 }}>
        {title}
      </Typography>
      <Box sx={{ color }}>
        {icon}
      </Box>
    </Box>
    <Box mt={2}>
      <Typography variant="h4" sx={{ color: "#212529", fontWeight: 700, fontSize: 32 }}>
        {value}
      </Typography>
      <Typography variant="body2" sx={{ color: variation.startsWith('+') ? '#2ecc40' : '#e74c3c', fontWeight: 600, fontSize: 15 }}>
        {variation}
      </Typography>
    </Box>
  </Box>
);

export default DashboardStatCard;
